import { aiMessages } from '@atlaskit/editor-common/ai-messages/ai';

import { createInsertBelow } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemFactory,
	EditorPluginAIConfigItemFactoryOptions,
} from '../../config-items';

export type DraftContentActionType = 'summarize_changes' | 'draft_release_notes';

type SmartlinkDraftContentOptions = EditorPluginAIConfigItemFactoryOptions & {
	actionType: DraftContentActionType;
	smartlinkUrl: string;
};

type SmartlinkDraftContentConfigItemFactory = (
	options: SmartlinkDraftContentOptions,
) => ReturnType<EditorPluginAIConfigItemFactory>;

export const smartLinkDraftContent: SmartlinkDraftContentConfigItemFactory = (
	options: SmartlinkDraftContentOptions,
) => ({
	key: CONFIG_ITEM_KEYS.SMARTLINK_DRAFT_CONTENT,
	title: aiMessages.smartlinkSummarizeChanges,
	description: aiMessages.smartlinkSummarizeChanges,
	showInRefineDropdown: false,
	insertOnEmptySelection: true,
	// intentSchemaId is not being passed to the backend. it's used in `request-options-convo-ai.ts` for error logging
	intentSchemaId: 'smartlink_draft_content_intent_schema.json',
	featureId: 'smartlink_draft_content',
	adfPrompt: true,
	getRequestPayload: ({ locale, aiSessionId, contentAri }) => ({
		ai_feature_input: {
			feature: 'smartlink_draft_content',
			feature_args: {
				smartlink_url: options.smartlinkUrl,
				smartlink_action_type: options.actionType,
			},
			locale,
			ai_session_id: aiSessionId,
			content_ari: contentAri,
		},
	}),
	actions: {
		empty: [createInsertBelow({ appearance: 'primary' })],
		selection: [createInsertBelow({ appearance: 'primary' })],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});
